import { Trans } from 'react-i18next'

import { useDeviceIdProvider, useOS, usePhoneNumber } from '../../../hooks'
import { Text } from '../../basics'
import { Modal } from '../../basics/Modal'

const androidPermission1 = '/modal/android-permission1.png'
const androidPermission2 = '/modal/android-permission2.png'
const iosPermission1 = '/modal/ios-permission1.png'
const iosPermission2 = '/modal/ios-permission2.png'

export function DevicePermissionModal() {
  const { deviceId } = useDeviceIdProvider()
  const os = useOS()
  const { phoneNumber } = usePhoneNumber(deviceId || null)

  return (
    <Modal open={true} closable={false} size="large">
      <div className="mb-10 flex flex-col gap-y-8">
        <div className="flex flex-col gap-y-4">
          <Text size="lg2" align="center">
            <Trans
              i18nKey="components.DevicePermissionModal.description"
              tOptions={{ lng: 'ja' }}
            />
          </Text>
          <Text size="lg2" align="center">
            <Trans
              i18nKey="components.DevicePermissionModal.description"
              tOptions={{ lng: 'en' }}
            />
          </Text>
        </div>
        <div className="flex flex-col gap-y-4">
          <Text size="lg3" align="center">
            {os === 'ios' ? 'Safari (iOS)' : 'Chrome (Android)'}
          </Text>
          <Text size="lg2" align="center">
            <Trans
              i18nKey="components.DevicePermissionModal.howTo"
              tOptions={{ lng: 'ja' }}
            />
          </Text>
          <Text size="lg2" align="center">
            <Trans
              i18nKey="components.DevicePermissionModal.howTo"
              tOptions={{ lng: 'en' }}
            />
          </Text>
          <div className="flex justify-center px-20">
            <img src={os === 'ios' ? iosPermission1 : androidPermission1} />
          </div>
          <div className="flex justify-center px-20">
            <img src={os === 'ios' ? iosPermission2 : androidPermission2} />
          </div>
        </div>
        <div className="flex flex-col gap-y-4">
          <Text size="lg2" align="center">
            <Trans
              i18nKey="components.DevicePermissionModal.contact"
              tOptions={{ lng: 'ja' }}
            />
          </Text>
          <Text size="lg2" align="center">
            <Trans
              i18nKey="components.DevicePermissionModal.contact"
              tOptions={{ lng: 'en' }}
            />
          </Text>
          {phoneNumber && (
            <div className="mt-4">
              <Text size="lg2" align="center">
                <Trans
                  i18nKey="components.DevicePermissionModal.phoneNumber"
                  tOptions={{ lng: 'ja', phoneNumber }}
                />
              </Text>
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}
